// app dependencies
import Firebase from 'firebase';
import window from 'global/window';
import document from 'global/document';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';

// admin utility class
import {AdminUtilities} from './Utilities/AdminUtilities';

// components
import Questions from './components/Questions.jsx';
import Categories from './components/Categories.jsx';

// use environment vars if they are there
const NODE_ENV = process.env.NODE_ENV || "production";

// DEVELOPMENT
let API_KEY = process.env.API_KEY || 'AIzaSyB7_JXkmDVBO03HCtIQoMcj0vQLJxLEf_A';
let AUTH_DOMAIN = process.env.AUTH_DOMAIN || 'doubleact-robot-face.firebaseapp.com';
let DATABASE_URL = process.env.DATABASE_URL || 'https://doubleact-robot-face.firebaseio.com';
let STORAGE_BUCKET = process.env.STORAGE_BUCKET || 'doubleact-robot-face.appspot.com';
let DOMAIN = 'doubleact-robot-face';
if (NODE_ENV === "production") {
  // PRODUCTION
  console.warn("Running on PRODUCTION instance");
  API_KEY = process.env.API_KEY || 'AIzaSyB7_JXkmDVBO03HCtIQoMcj0vQLJxLEf_A';
  AUTH_DOMAIN = process.env.AUTH_DOMAIN || 'doubleact-robot-face.firebaseapp.com';
  DATABASE_URL = process.env.DATABASE_URL || 'doubleact-robot-face.firebaseio.com';
  STORAGE_BUCKET = process.env.STORAGE_BUCKET || 'doubleact-robot-face.appspot.com';
  let DOMAIN = 'doubleact-robot-face';
} else {
  console.info("Running on DEVELOPMENT instance");
}

const cats = document.getElementById('categories');
const catsUL = document.getElementById('all-categories');

class Admin {

  constructor() {


  }

  init() {

    console.log("done")

    this.login = document.getElementById('login');
    this.submit = document.getElementById('submit');
    this.submit.addEventListener('click', this.doLogin.bind(this));

    document.getElementById("main").style.display = 'block';
    document.getElementById("login").style.display = 'none';
    this.doAuth();

  }

  doAuth() {
    this.initFirebase();
    this.user = {};
    this.questions = [];
    this.resources = [];
    this.categories = [];
    this.quizzes = [];

    let faceRef = this.database.ref('state');

    for (var i = 1; i <= 8; i++) {
      var btn = document.getElementById('b' + i);

      btn.addEventListener('click', function (ev) {
        var no = ev.currentTarget.getAttribute('data-face');
        var curr = ev.currentTarget;
        faceRef.set(no).then(() => {
          console.log('Face ' + no);
          document.getElementById('status').innerHTML = curr.value;

        }).catch(function (error) {
          console.error('Error', error);
        });
      });
    }

    document.addEventListener("keydown", keyDownTextField, false);

    function keyDownTextField(e) {
      e.preventDefault();
      var keyCode = e.keyCode;
      console.log(keyCode);
      if (keyCode >= 48 && keyCode <= 57) {
        var n = keyCode - 48;
        eventFire(document.getElementById('b' + n), 'click');
        setTimeout(() => {
          document.getElementById('b' + n).focus();
        }, 0);
      }

      if(e.keyCode == 32){
        document.getElementById('b1').focus();
        eventFire(document.getElementById('b1'), 'click');

      }
    }


    function eventFire(el, etype) {
      if (el.fireEvent) {
        el.fireEvent('on' + etype);
      } else {
        var evObj = document.createEvent('Events');
        evObj.initEvent(etype, true, false);
        el.dispatchEvent(evObj);
      }
    }


    // this.add = document.getElementById('add-question-form');
    // this.add.addEventListener('submit', this.addQuestion.bind(this));
    //
    // this.quizForm = document.getElementById('add-quiz-form');
    // this.quizForm.addEventListener('submit', this.addQuiz.bind(this));
    //
    // this.resourceForm = document.getElementById('add-resource-form');
    // this.resourceForm.addEventListener('submit', this.addResource.bind(this));


  }

  doLogin(ev) {

    console.log(ev)

    ev.preventDefault();

    // NB - this really needs server auth!
    let username = document.getElementById("username").value;
    let password = document.getElementById("password").value;

    if (password === 'mastery') {
      document.getElementById("main").style.display = 'block';
      document.getElementById("login").style.display = 'none';
      this.doAuth();
    }
  }

  initFirebase() {

    // Initialize Firebase
    let config = {
      apiKey: API_KEY,
      authDomain: AUTH_DOMAIN,
      databaseURL: DATABASE_URL,
      storageBucket: STORAGE_BUCKET
    };
    Firebase.initializeApp(config);

    // Shortcuts to Firebase SDK features.
    this.auth = Firebase.auth();
    this.database = Firebase.database();
    this.storage = Firebase.storage();

    this.quizzesRef = this.database.ref('quizzes');
    this.quizzesRef.orderByChild("category").on('child_added', this.setQuizzes.bind(this));
    this.quizzesRef.orderByChild("category").once('value', () => {

      const select = document.getElementById('quizzes');
      const quizzesUL = document.getElementById('all-quizzes');
      this.quizzes.forEach(quiz => {
        let option = document.createElement('option');
        option.value = quiz.id;
        option.innerHTML = quiz.category + " - " + quiz.difficulty + " - " + quiz.title;
        select.appendChild(option);

        let li = document.createElement('li');
        li.innerHTML = '<a target="_blank" href="https://console.firebase.google.com/project/' + DOMAIN + '/database/data/quizzes/' + quiz.id + '">' + quiz.category + ' - ' + quiz.difficulty + ' - ' + quiz.title + '</a>';
        quizzesUL.appendChild(li);
      });

      setTimeout(() => {
        console.info(this.quizzes)
        this.getQuestions()
      }, 10)

    })
    //
    this.resRef = this.database.ref('resources');
    this.resRef.on('child_added', this.setResources.bind(this));

    this.catRef = this.database.ref('categories');
    this.catRef.on('child_added', this.setCategories.bind(this));

    // Set up admin utilities for access through console
    AdminUtilities.init(this.database);
    window.AdminUtilities = AdminUtilities;
  }

  getQuestions() {
    this.questionsRef = this.database.ref('questions');
    this.questionsRef.once('value', this.setQuestions.bind(this));
  }

  clearOnline() {
    this.onlineRef = this.database.ref('online');
    this.onlineRef.once('value', snapshot => {
      if (!snapshot.exists()) return false;
      let online_data = snapshot.val();
      _.mapKeys(online_data, (value, key) => {
        let u = value;
        u.id = key;

        let ref = this.database.ref('online/' + key);
        ref.update({active: null, connected: 1484743015405}).then(() => {
          console.log('Saved online for ' + key);
        })
          .catch(function (error) {
            console.error('Error', error);
          });
      });
    });
  }

  fixStatXP() {
    let c = 0;
    this.quizRef = this.database.ref('quizzes');
    this.quizRef.on('child_added', quizS => {

      let quiz = quizS.val();
      let quizId = quizS.key;

      this.scoresRef1 = this.database.ref('scores/quizzes/' + quizId);

      let count = 0;
      // filters out only active users
      this.scoresRef1.orderByChild("xp").startAt(1).once('value', snapshot => {
        if (!snapshot.exists()) return false;
        let scores_data = snapshot.val();
        _.mapKeys(scores_data, (value, key) => {
          let u = value;
          u.id = key;
          // if (!u.won && !u.lost) u.new = true;
          if (!u.won) u.won = 0;
          if (!u.lost) u.lost = 0;
          // scores.push(u);
          if (!u.correct) u.correct = 0;
          if (!u.incorrect) u.incorrect = 0;
          let played = parseInt((u.correct + u.incorrect) / 5, 10);
          let played2 = (u.won + u.lost);
          // console.log("Q1", u.id, u.xp, played, played2);

          let unknown = played - played2;
          let totalWins = u.won;

          // console.log(unknown, "games unaccounted for")

          if (played2 < played) totalWins = unknown + u.won;

          let stat = {
            Correct: u.correct,
            Incorrect: u.incorrect,
            XP: u.xp,
          }

          count++;
          c++;

          console.log(c, quizId, count, stat);

          // update stats
          let statRef = this.database.ref('stats/' + u.id + '/' + quizId);
          statRef.update(stat).then(() => {
            console.log('Saved XP stat for ' + u.id, stat);
          }).catch(function (error) {
            console.error('Error', error);
          });

          // update quiz total
          let scoreRef = this.database.ref('scores/quizzes/' + quizId + '/' + u.id);
          scoreRef.update({won: totalWins}).then(() => {
            console.log('Saved quiz score wins for ' + u.id, totalWins);
          }).catch(function (error) {
            console.error('Error', error);
          });
        });
      });

    });

    this.scoresRef2 = this.database.ref('scores/users');

    let count = 0;
    // filters out only active users
    this.scoresRef2.orderByChild("xp").startAt(1).once('value', snapshot => {
      if (!snapshot.exists()) return false;
      let scores_data = snapshot.val();
      _.mapKeys(scores_data, (value, key) => {
        let u = value;
        u.id = key;
        // if (!u.won && !u.lost) u.new = true;
        if (!u.won) u.won = 0;
        if (!u.lost) u.lost = 0;
        // scores.push(u);
        if (!u.correct) u.correct = 0;
        if (!u.incorrect) u.incorrect = 0;
        let played = parseInt((u.correct + u.incorrect) / 5, 10);
        let played2 = (u.won + u.lost);
        // console.log("Q1", u.id, u.xp, played, played2);

        let unknown = played - played2;
        let totalWins = u.won;

        // console.log(unknown, "games unaccounted for")

        if (played2 < played) totalWins = unknown + u.won;

        let stat = {
          NumGames: played,
          NumWins: totalWins,
          NumLost: u.lost,
          Correct: u.correct,
          Incorrect: u.incorrect,
          XP: u.xp
        }

        count++;
        c++;

        console.log(c, u.id, count, stat);

        // update quiz total
        let scoreRef = this.database.ref('scores/users/' + u.id);
        scoreRef.update({won: totalWins}).then(() => {
          console.log('Saved user score wins for ' + u.id, totalWins);
        }).catch(function (error) {
          console.error('Error', error);
        });
      });
    });
  }

  fixStatWins() {
    let c = 0;
    this.quizRef = this.database.ref('quizzes');
    this.quizRef.on('child_added', quizS => {

      let quiz = quizS.val();
      let quizId = quizS.key;

      this.scoresRef1 = this.database.ref('scores/quizzes/' + quizId);

      let count = 0;
      // filters out only active users
      this.scoresRef1.orderByChild("xp").startAt(1).once('value', snapshot => {
        if (!snapshot.exists()) return false;
        let scores_data = snapshot.val();
        _.mapKeys(scores_data, (value, key) => {
          let u = value;
          u.id = key;
          // if (!u.won && !u.lost) u.new = true;
          if (!u.won) u.won = 0;
          if (!u.lost) u.lost = 0;
          // scores.push(u);
          if (!u.correct) u.correct = 0;
          if (!u.incorrect) u.incorrect = 0;
          let played = parseInt((u.correct + u.incorrect) / 5, 10);
          let played2 = (u.won + u.lost);
          // console.log("Q1", u.id, u.xp, played, played2);

          let unknown = played - played2;
          let totalWins = u.won;

          // console.log(unknown, "games unaccounted for")

          if (played2 < played) totalWins = unknown + u.won;

          let stat = {
            IsCertified: "No",
            LDAP: key,
            NumGames: played,
            NumWins: totalWins,
            NumLost: u.lost,
            Correct: u.correct,
            Incorrect: u.incorrect,
            XP: u.xp,
            QuizzID: quizId,
            QuizzTitle: quiz.title
          }

          count++;
          c++;

          console.log(c, quizId, count, stat);

          // update stats
          let statRef = this.database.ref('stats/' + u.id + '/' + quizId);
          statRef.set(stat).then(() => {
            console.log('Saved stat for ' + u.id, stat);
          }).catch(function (error) {
            console.error('Error', error);
          });

          // update quiz total
          let scoreRef = this.database.ref('scores/quizzes/' + quizId + '/' + u.id);
          scoreRef.update({won: totalWins}).then(() => {
            console.log('Saved quiz score wins for ' + u.id, totalWins);
          }).catch(function (error) {
            console.error('Error', error);
          });
        });
      });

    });

    this.scoresRef2 = this.database.ref('scores/users');

    let count = 0;
    // filters out only active users
    this.scoresRef2.orderByChild("xp").startAt(1).once('value', snapshot => {
      if (!snapshot.exists()) return false;
      let scores_data = snapshot.val();
      _.mapKeys(scores_data, (value, key) => {
        let u = value;
        u.id = key;
        // if (!u.won && !u.lost) u.new = true;
        if (!u.won) u.won = 0;
        if (!u.lost) u.lost = 0;
        // scores.push(u);
        if (!u.correct) u.correct = 0;
        if (!u.incorrect) u.incorrect = 0;
        let played = parseInt((u.correct + u.incorrect) / 5, 10);
        let played2 = (u.won + u.lost);
        // console.log("Q1", u.id, u.xp, played, played2);

        let unknown = played - played2;
        let totalWins = u.won;

        // console.log(unknown, "games unaccounted for")

        if (played2 < played) totalWins = unknown + u.won;

        let stat = {
          NumGames: played,
          NumWins: totalWins,
          NumLost: u.lost,
          Correct: u.correct,
          Incorrect: u.incorrect,
          XP: u.xp
        }

        count++;
        c++;

        console.log(c, u.id, count, stat);

        // update quiz total
        let scoreRef = this.database.ref('scores/users/' + u.id);
        scoreRef.update({won: totalWins}).then(() => {
          console.log('Saved user score wins for ' + u.id, totalWins);
        }).catch(function (error) {
          console.error('Error', error);
        });
      });
    });
  }

  compileStats() {
    this.scoresRef1 = this.database.ref('scores/quizzes/-KSSxSj0hGY3bFVo3lOZ');
    this.scoresRef1.orderByChild("xp").startAt(1).once('value', snapshot => {
      if (!snapshot.exists()) return false;
      let scores_data = snapshot.val();
      _.mapKeys(scores_data, (value, key) => {
        let u = value;
        u.id = key;
        // if (!u.won && !u.lost) u.new = true;
        if (!u.won) u.won = 0;
        if (!u.lost) u.lost = 0;
        // scores.push(u);
        if (!u.correct) u.correct = 0;
        if (!u.incorrect) u.incorrect = 0;
        let played = parseInt((u.correct + u.incorrect) / 5, 10);
        let played2 = (u.won + u.lost);
        console.log("Q1", u.id, u.xp, played, played2);

        let stat = {
          IsCertified: "No",
          LDAP: key,
          NumGames: played,
          NumWins: u.won,
          QuizzID: "-KSSxSj0hGY3bFVo3lOZ",
          QuizzTitle: "General Knowledge Quiz"
        }

        let statRef = this.database.ref('stats/' + u.id + '/-KSSxSj0hGY3bFVo3lOZ');
        statRef.set(stat).then(() => {
          console.log('Saved stat for ' + u.id, stat);
        })
          .catch(function (error) {
            console.error('Error', error);
          });
      });
    });

    this.scoresRef2 = this.database.ref('scores/quizzes/-KYJt7XAGe3W5WNydqQz');
    this.scoresRef2.orderByChild("xp").startAt(1).once('value', snapshot => {
      if (!snapshot.exists()) return false;
      let scores_data = snapshot.val();
      _.mapKeys(scores_data, (value, key) => {
        let u = value;
        u.id = key;
        // if (!u.won && !u.lost) u.new = true;
        if (!u.won) u.won = 0;
        if (!u.lost) u.lost = 0;
        // scores.push(u);
        if (!u.correct) u.correct = 0;
        if (!u.incorrect) u.incorrect = 0;
        let played = parseInt((u.correct + u.incorrect) / 5, 10);
        let played2 = (u.won + u.lost);
        console.log("Q2", u.id, u.xp, played, played2);

        let stat = {
          IsCertified: "No",
          LDAP: key,
          NumGames: played,
          NumWins: u.won,
          QuizzID: "-KYJt7XAGe3W5WNydqQz",
          QuizzTitle: "Apps Black Belt Basic"
        }

        let statRef = this.database.ref('stats/' + u.id + '/-KYJt7XAGe3W5WNydqQz');
        statRef.set(stat).then(() => {
          console.log('Saved stat for ' + u.id, stat);
        })
          .catch(function (error) {
            console.error('Error', error);
          });
        ;
      });
    });
  }

  setCategories(data) {
    let cat = data.val();
    this.categories = this.categories ? this.categories : [];
    this.categories.push(
      {
        id: data.key,
        name: cat
      }
    )
    // let li = document.createElement('li');
    // li.innerHTML = '<a target="_blank" href="https://console.firebase.google.com/project/master-faster-client-dev1/database/data/categories/' + cat.key + '">' + cat + '</a>';
    // catsUL.appendChild(li);

    ReactDOM.render(
      React.createElement(Categories, {
        categories: this.categories,
        domain: DOMAIN
      }),
      cats
    );

  }

  setResources(data) {
    let resource = data.val();
    resource.id = data.key;
    this.resources = [];
    this.resources.push(resource);

    const resourceSelect = document.getElementById('resources');
    const resourcesUL = document.getElementById('all-resources');
    this.resources.forEach(resource => {
      let option = document.createElement('option');
      option.value = resource.id;
      option.innerHTML = resource.title;
      resourceSelect.appendChild(option);

      let li = document.createElement('li');
      li.innerHTML = '<a target="_blank" href="https://console.firebase.google.com/project/' + DOMAIN + '/database/data/resources/' + resource.id + '">' + resource.title + '</a>';
      resourcesUL.appendChild(li);
    });
  }

  setQuizzes(data) {
    let u = data.val();
    u.id = data.key;
    this.quizzes.push(u);

    console.log('setQuizzes', u)
  }

  setQuestions(data) {

    if (!data.exists()) return false;

    let u = data.val();
    u.id = data.key;

    let quizList = this.quizzes;
    let quizQs = {};
    this.quizzes.map(quiz => {
      // console.log(quiz);
      quizQs[quiz.id] = quiz;
      quizQs[quiz.id].questions = [];
    });

    // console.info(quizQs);
    this.questions = _.filter(u, (qs, key) => {
      let q = qs;
      if (q === 'questions') return false;
      q.id = key;
      return q;
    });

    const questionsUL = document.getElementById('all-questions');

    this.questions.map(question => {
      let numQuizzes = 0;
      for (let quizId in question.quizzes) {
        // console.log(question, quizQs, quizId)
        question.quiz = quizQs[quizId].title;
        question.difficulty = quizQs[quizId].difficulty;
        numQuizzes++;
      }

      return question;

    });


    ReactDOM.render(
      React.createElement(Questions, {
        questions: this.questions,
        quizzes: this.quizzes,
        domain: DOMAIN
      }),
      questionsUL
    );
  }

  getSelectValues(select) {
    let result = [];
    let options = select && select.options;
    let opt;

    for (let i = 0, iLen = options.length; i < iLen; i++) {
      opt = options[i];

      if (opt.selected) {
        result.push(opt.value || opt.text);
      }
    }
    return result;
  }

  addQuestion(ev) {
    ev.preventDefault();

    this.questionsRef = this.database.ref('questions');

    let quizzes = this.getSelectValues(this.add.quizzes);
    let resources = this.getSelectValues(this.add.resources);

    let newQuestionRef = this.questionsRef.push();

    let newQuestionObject = {
      "answers": [
        {
          "correct": this.add['answer1-correct'].checked,
          "feedback": "",
          "text": this.add['answer1'].value
        },
        {
          "correct": this.add['answer2-correct'].checked,
          "feedback": "",
          "text": this.add['answer2'].value
        }
      ],
      "feedbackCorrect": this.add['feedback-correct'].value,
      "feedbackIncorrect": this.add['feedback-incorrect'].value,
      "question": this.add['question'].value
    };
    if (this.add['answer3'].value) {
      newQuestionObject.answers.push(
        {
          "correct": this.add['answer3-correct'].checked,
          "feedback": "",
          "text": this.add['answer3'].value
        }
      );
    }
    if (this.add['answer4'].value) {
      newQuestionObject.answers.push(
        {
          "correct": this.add['answer4-correct'].checked,
          "feedback": "",
          "text": this.add['answer4'].value
        }
      );
    }

    let quizzesObj = {};
    quizzes.forEach(quizKey => {
      quizzesObj[quizKey] = true;

      // add the question key to the quiz object too (better to do this in Firebase apparently - data in more places, so it seems a little weird coming from a relational DB point of view)
      let qzRef = this.database.ref('quizzes/' + quizKey + '/questions');
      qzRef.child(newQuestionRef.key).set(true)
        .then(() => {
          console.log('Saved question to quiz ' + quizKey);
        })
        .catch(function (error) {
          console.error('Error saving question to quiz', error);
        });
    });

    let resourcesObj = {};
    resources.forEach(resourceKey => {
      resourcesObj[resourceKey] = true;

      // add the question key to the resource object too for resource > question look ups
      let resRef = this.database.ref('resources/' + resourceKey + '/questions');
      resRef.child(newQuestionRef.key).set(true)
        .then(() => {
          console.log('Saved question to resource ' + resourceKey);
        })
        .catch(function (error) {
          console.error('Error saving question to resource', error);
        });

    });

    newQuestionObject.quizzes = quizzesObj;
    newQuestionObject.resources = resourcesObj;

    newQuestionRef.set(newQuestionObject);

    // We've appended a new message to the firebase database - get the location/path.
    let path = newQuestionRef.toString();

    console.log("Added: ", path);

    document.getElementById("feedback").innerHTML = "Added: <a target=\"_blank\" href='" + path + "'>" + path + "</a>";
  }

  addQuiz(ev) {
    ev.preventDefault();
    this.questionsRef = this.database.ref('quizzes');
    let newQuizRef = this.questionsRef.push();
    newQuizRef.set(
      {
        "category": this.quizForm['quiz-category'].value,
        "difficulty": this.quizForm['quiz-difficulty'].value,
        "title": this.quizForm['quiz-name'].value
      }
    );
    // We've appended a new message to the message_list location.
    let path = newQuizRef.toString();

    console.log("Added quiz: ", path);

    document.getElementById("feedback-quiz").innerHTML = "Added: <a target=\"_blank\" href='" + path + "'>" + path + "</a>";
  }

  addResource(ev) {
    ev.preventDefault();
    this.resourcesRef = this.database.ref('resources');
    let newResourceRef = this.resourcesRef.push();
    newResourceRef.set(
      {
        title: this.resourceForm['resource-name'].value,
        link: this.resourceForm['resource-link'].value
      }
    );
    // We've appended a new message to the message_list location.
    let path = newResourceRef.toString();

    console.log("Added resource: ", path);

    document.getElementById("feedback-quiz").innerHTML = "Added: <a target=\"_blank\" href='" + path + "'>" + path + "</a>";

  }

}

(new Admin()).init();
